export default __webpack_public_path__ + "static/media/bg-stage2.2c0a4ddf.png";